import { AfterViewInit, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DividerModule } from 'primeng/divider';
import { RippleModule } from 'primeng/ripple';
import { InputComponent } from '../../common/components/form-components/input/input';
import { Button } from '../../common/components/form-components/button/button';
import { Dropdown } from '../../common/components/form-components/dropdown/dropdown';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CarouselModule } from 'primeng/carousel';
import { LoginService } from '../services/login-service';
import { TranslateService } from '../../i18n/translate.service';

@Component({
  selector: 'app-login',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CardModule,
    ButtonModule,
    DividerModule,
    RippleModule,
    RouterModule,
    InputComponent,
    Button,
    Dropdown,
    CarouselModule,
    HttpClientModule,
  ],
  templateUrl: './login.html',
  styleUrl: './login.scss',
})
export class Login implements AfterViewInit {
  @ViewChild('emailRef') InputComponent!: any;

  loginForm: any;
  submitted: boolean = false;
  products = [
    { id: 1, name: 'Budget', image: 'Group.svg' },
    { id: 2, name: 'Efficient Planning', image: 'org-detail.svg' },
    { id: 3, name: 'Manage Resources', image: 'personal-details.svg' },
  ];

  loading: boolean = false;
  showOrgSelection: boolean = false;
  organizations: any[] = [];
  email: string = '';
  selectedOrgId: any = null;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    public Route: ActivatedRoute,
    private http: HttpClient,
    private mLoginService: LoginService,
    private cdr: ChangeDetectorRef,
    readonly i18n: TranslateService

  ) {
    let email = this.mLoginService.loggedInUserDetails
      ? this.mLoginService.loggedInUserDetails.email
      : '';
    this.loginForm = this.fb.group({
      email: [email, [Validators.required, Validators.email]],
      remember: [false],
    });

  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.InputComponent.focusInput();
    }, 0);
  }

  onLogin() {
    this.submitted = true;
    if (this.loginForm.invalid) {
      this.resetLoginForm(true);
      return;
    } else {
      this.loading = true;
      let payloadForUserOrganizations = { Email: this.loginForm.controls.email.value };
      this.mLoginService.GetUserOrganizations(payloadForUserOrganizations).subscribe({
        next: (res: any) => {
          this.loading = false;
          console.log('Login success:', res);

          // window.location.href = 'http://plandag.local:4201';
          if (res.data == null) {
            this.resetLoginForm(res.data);
          } else {
            this.mLoginService.getUserDetails(res.data);
            this.organizations = res.data.organizationIds || [];
            this.email = res.data.email || '';

            if (this.organizations.length > 1) {
              this.showOrgSelection = true;
            } else if (this.organizations.length === 1) {
              this.proceedToPassword(res.data);
            } else {
              this.resetLoginForm(null);
            }
          }
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.loading = false;
          this.resetLoginForm(null);
          this.cdr.detectChanges();
        },
      });
    }
  }

  proceedToPassword(userData: any) {
    this.mLoginService.getUserDetails(userData);
    this.router.navigate(['password'], {
      relativeTo: this.Route,
    });
  }

  onSelectOrg() {
    if (!this.selectedOrgId) return;
    const selectedOrg = this.organizations.find(org => org.id === this.selectedOrgId);
    let userData = { ...this.mLoginService.loggedInUserDetails, organizationIds: [selectedOrg] };
    this.proceedToPassword(userData);
  }

  backToEmail() {
    this.showOrgSelection = false;
    this.submitted = false;
    this.selectedOrgId = null;
    this.organizations = [];
  }

  resetLoginForm(from: any) {
    if (from == null) {
      this.loginForm.controls.email.setErrors({ email: true });
      this.loginForm.controls.email.markAsTouched();
    } else {
      this.loginForm.controls.email.markAsDirty();
      this.loginForm.controls.email.markAsTouched();
      this.loginForm.controls.email.updateValueAndValidity({ emitEvent: true });
    }
  }
}
